/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import sumTableValue from '../../../../components/Table/Utils/sumTableValue';
import {convertPxToRem} from '../../../../utils/commonFunctions';
import {formatIndian} from '../../../../utils/formatIndian';
import {
  convertGjToTjValue,
  convertGjToTjValueUnitObject
} from '../../../../utils/formatValueWithUnit';
import {roundToDecimal} from '../../constants/commonFunctions';

import CountBoxSingle from './CountBoxSingle';

const FacilityCount: React.FC<{
  subData: any[];
  leased: any[];
  nonLeased: any[];
  isSingle?: boolean;
  customTitle?: string;
  isStream?: boolean;
  mainData: any | any[];
  customCalKey?: string;
  isCost?: boolean;
  convertToTJ?: boolean;
}> = ({
  subData,
  leased,
  nonLeased,
  isSingle = false,
  customTitle = '',
  isStream = false,
  mainData,
  customCalKey = '',
  isCost = false,
  convertToTJ = false
}) => {
  const isArray = Array.isArray(mainData);
  const mainImageIsArray = Array?.isArray(mainData?.image);

  return (
    <Flex gap={convertPxToRem(20.5)}>
      <CountBoxSingle
        title={
          customTitle !== ''
            ? customTitle
            : isSingle
              ? 'TOTAL SUPPLIERS'
              : 'TOTAL NO. OF FACILITY'
        }
        image={
          isArray
            ? mainData?.[0]?.image
            : mainImageIsArray
              ? mainData?.image?.[0]
              : mainData?.image
        }
        value={{
          total: formatIndian(
            customCalKey !== ''
              ? roundToDecimal(
                  Number(sumTableValue(subData, customCalKey, false))
                )
              : subData?.length ?? 0
          ),
          value1: formatIndian(
            customCalKey !== ''
              ? roundToDecimal(
                  Number(sumTableValue(leased, customCalKey, false))
                )
              : leased?.length ?? 0
          ),
          value2: formatIndian(
            customCalKey !== ''
              ? roundToDecimal(
                  Number(sumTableValue(nonLeased, customCalKey, false))
                )
              : nonLeased?.length ?? 0
          )
        }}
        text={
          isStream
            ? {
                totalUnit: customCalKey !== '' ? mainData?.unit ?? '' : 'No.',
                label1: 'Upstream',
                label2: 'Downstream'
              }
            : {
                totalUnit: customCalKey !== '' ? mainData?.unit ?? '' : 'No.',
                label1: 'Leased Space',
                label2: 'Non Leased Space'
              }
        }
        isCost={isCost}
      />
      {!isSingle ? (
        <CountBoxSingle
          title="ENERGY CONSUMPTION"
          image={
            isArray
              ? mainData?.[1]?.image
              : mainImageIsArray
                ? mainData?.image?.[1]
                : mainData?.image
          }
          value={{
            total: convertToTJ
              ? convertGjToTjValue(
                  Number(sumTableValue(subData, 'energyConsumption', false)),
                  subData?.[0]?.energyConsumptionUnit ?? 'GJ'
                )
              : formatIndian(
                  roundToDecimal(
                    Number(sumTableValue(subData, 'energyConsumption', false))
                  )
                ),
            value1: convertToTJ
              ? convertGjToTjValue(
                  Number(sumTableValue(leased, 'energyConsumption', false)),
                  subData?.[0]?.energyConsumptionUnit ?? 'GJ'
                )
              : formatIndian(
                  roundToDecimal(
                    Number(sumTableValue(leased, 'energyConsumption', false))
                  )
                ),
            value2: convertToTJ
              ? convertGjToTjValue(
                  Number(sumTableValue(nonLeased, 'energyConsumption', false)),
                  subData?.[0]?.energyConsumptionUnit ?? 'GJ'
                )
              : formatIndian(
                  roundToDecimal(
                    Number(sumTableValue(nonLeased, 'energyConsumption', false))
                  )
                )
          }}
          text={{
            totalUnit: convertToTJ
              ? convertGjToTjValueUnitObject(
                  Number(sumTableValue(subData, 'energyConsumption', false)),
                  subData?.[0]?.energyConsumptionUnit ?? 'GJ'
                )?.unit
              : subData?.[0]?.energyConsumptionUnit ?? 'GJ',
            label1: 'Leased Space',
            label2: 'Non Leased Space'
          }}
          isCost={isCost}
        />
      ) : (
        <div style={{flex: 0.3}}></div>
      )}
    </Flex>
  );
};

export default FacilityCount;
